var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-btn',{staticStyle:{"margin-top":"-4px"},attrs:{"dense":"","round":"","flat":"","color":"primary","icon":"fas fa-plus"},on:{"click":function($event){return _vm.addbutton()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }